import { invokeApi } from "../../bl_libs/invokeApi";

const authHeaders = () => ({ "x-sh-auth": localStorage.getItem("token") });

// Independent instructor accounts. An instructor is a one-person FlightSchool
// (schoolType "independent_instructor") whose primary_admin is the instructor
// themselves, so everything after signup is the ordinary school portal.

// Public: email + password signup. Returns { code: 200, token, adminUser }
// in the same shape as admin_users login, so the caller can store auth the
// way Login.jsx does.
export const instructor_signup_api = async (data) =>
  invokeApi({ path: `api/instructors/signup`, method: "POST", headers: {}, postData: data });

// Public: Google signup. Same response shape. A 409 means the email already
// has an account, and the caller should fall back to admin_users/google_signin.
export const instructor_google_signup_api = async (credential, extra = {}) =>
  invokeApi({ path: `api/instructors/signup/google`, method: "POST", headers: {}, postData: { credential, ...extra } });

// Auth (school admin JWT). { code, url } for the public join page. The code is
// the instructor's name ("jamie-bannon") and is permanent — there is no
// regenerate, because the link lives in other people's chat histories.
export const get_instructor_join_link_api = async () =>
  invokeApi({ path: `api/instructors/me/join-link`, method: "GET", headers: authHeaders() });

// Auth. { code, data: { applies, complete, steps: { connect, rates, students,
// calendar }, studentCount } }. `applies:false` means this account is not
// gated — the guard reads that as complete. See the controller for why.
export const get_instructor_onboarding_api = async () =>
  invokeApi({ path: `api/instructors/me/onboarding`, method: "GET", headers: authHeaders() });
